module.exports = __webpack_public_path__ + "img/checkbox-null.b7480488.svg";